import {
  project_report_show_form_path,
  project_report_update_deadline_path,
  project_report_revert_submission_path,
  project_report_docusign_cancel_signing_path 
} from '~/routes';

export const ProjectReport = { 

  _forms: function () {

      var options = {
        bDeferRender: true,
        data: JSON.parse(jQuery('#list-data').html()),
        info: false,
        lengthChange: false,
        language: {
          searchPlaceholder: I18n.t('search')
        },
        pageLength: 20,
        columnDefs: [
          {
            render: function (data, type, row, meta) {
              if (type == 'display') {
                return jQuery('#form-name-template').html()
                  .replace(/__label__/g, data.label)
                  .replace(/__project_report_id__/g, data.project_report_id)
                  .replace(/__id__/g, data.id);
              }
              return data.label;
            },
            targets: [0]
          },
        ],
        autoWidth: false,
        drawCallback: function() {
          jQuery('.report-form-link').on('click', function() {
            var container = $('div.sub-content, div.applicant-container, div.async-container');
            var link = $(this);
            $.ajax({ url: project_report_show_form_path({ 'form_id': link.data('form-id'), 'project_id': link.data('project-id'), 'layout': link.data('layout'), 'create': link.data('create'), project_report_id: link.data('project-report-id'), format: 'html' }) })
              .done(function (content) {
                container.html(content);
                $(window).trigger('formLoaded');
              });

            container.html(SmartME.loadingIndicator());
            return false;
          });
        },
        footerCallback: function () {
          DataTablesHelper.togglePagination(this);
        }
      };

      var formTable = jQuery('#project-report-table');
      formTable.DataTable(options);
    },

    _show_form: function() {
      jQuery('.report-form-link').on('click', function () {
        var container = $('div.sub-content, div.applicant-container, div.async-container');
        var link = $(this);
        $.ajax({ url: link.data('url') })
          .done(function (content) {
            container.html(content);
            $(window).trigger('formLoaded');
          });

        $('div.sub-content').html(SmartME.loadingIndicator());
        return false;
      });

      jQuery('.monitoring-form').each(function () {
        var formContainer = jQuery(this);
        SmartME.setLoadingIndicator(formContainer);
        formContainer.load(formContainer.attr('data-url'), function () {
          if (formContainer.find('.adalia-form').length > 0) {
            AdaliaForm.init(formContainer);
          }
        });
      });
    },

    reports_list: function(){
      if (!jQuery.fn.DataTable.isDataTable('table#reports-table')) {
        var columnNames = jQuery('table.reports').data('column-names')
        var columns = [
          {
            mRender: function (data, type, rowData) {
              if (type == 'display') {
                if (data.accessibility == 3) { // restricted: User access is based on restrictions
                  return jQuery('#monitoring-report-name-template-restricted').html().
                  replace(/__label__/g, data.label);
                } else if (data.project_report_id) {
                  return jQuery('#monitoring-report-name-template').html().
                  replace(/__label__/g, data.label).
                  replace(/__report_id__/g, data.report_id).
                  replace(/__project_report_id__/g, data.project_report_id).
                  replace(/__programme_identifier__/g, data.programme_identifier);
                }else{
                  return jQuery('#monitoring-report-name-template-no-report-id').html().
                  replace(/__label__/g, data.label).
                  replace(/__report_id__/g, data.report_id).
                  replace(/__programme_identifier__/g, data.programme_identifier);
                }
              }
              return data.label;
            },
            name: 'project_id',
            aTargets: [columnNames.indexOf('name')]
          },
          {
            mRender: function(data, type, rowData) {
              if (type == "display") {
                return data.label;
              }
              return data.value;
            },
            aTargets: [columnNames.indexOf("initial_submission"), columnNames.indexOf("last_modified"), columnNames.indexOf("status_updated")] // initial submission and status_updated_at
          },
          columnNames.includes('deadline') && {
            mRender: function(data, type, rowData) {
              if (type == 'display' && data && data.label && data.showEdit) {

                return jQuery('#deadline-cell-template').html()
                  .replace('__label__', data.label)
                  .replaceAll('__value__', data.value)
                  .replace('__id__', data.id);
              }
              return data.label;
            },
            aTargets: [columnNames.indexOf('deadline')]
          },
          {
            mRender: function(data, type, rowData) {
              if (type == 'display' && data && data.show) {
                return jQuery('#report-actions-template').html()
                  .replace('__id__', data.id);
              }
              return data.label;
            },
            aTargets: [columnNames.indexOf('actions')],
            orderable: false
          },
          {
            visible: false,
            targets: ActionJS.Monitoring.priv.getHiddenColumns()
          },
        ]
        var options = {
          bDeferRender: true,
          data: JSON.parse(jQuery('#list-data').html()),
          order: [[1, 'desc']],
          info: false,
          lengthChange: false,
          language: {
            searchPlaceholder: I18n.t('search')
          },
          pageLength: 20,
          autoWidth: false,
          aoColumnDefs: columns,
          initComplete: function () {
            DataTablesHelper.setAutoComplete(jQuery('#reports-table'));
          },
          drawCallback: function () {
            if (JSON.parse(jQuery(this).attr('data-filters'))[7].length > 1) {
              DataTablesHelper.addColumnFilters(this);
            }
          },
          footerCallback: function () {
            DataTablesHelper.togglePagination(this);
          },
          rowId: function(data){
            var id;
            if (data[columnNames.indexOf('deadline')] !== undefined){
              id = data[columnNames.indexOf('deadline')].id
            } else {
              id = data[columnNames.indexOf('name')].project_report_id
            }

            return `row-${id}`
          }
        };
    
        ActionJS.Monitoring.priv.projectReportTable = jQuery('#reports-table').DataTable(options);

        // Handle deadline updates
        jQuery('table.reports').on('click', '.edit-deadline', function(){
          var cell = ActionJS.Monitoring.priv.projectReportTable.cell($(this).closest('td'));
          
          var currentValueWrapper = jQuery(this).closest('td').find('.inline-value')
          var editWrapper = jQuery(this).closest('td').find('.inline-edit')

          currentValueWrapper.hide();          
          editWrapper.show();

          editWrapper.find('input').flatpickr({ dateFormat: "Y-m-d", allowInput: true})
          
          editWrapper.on('click', '.cancel', function(){
            editWrapper.off('click');
            editWrapper.hide();
            currentValueWrapper.show();
          })
          
          editWrapper.on('click', '.save', function(){
            var userSetValue = editWrapper.find('input').val();
            var reportId = currentValueWrapper.find('.edit-deadline').data('id')
            editWrapper.find('input', 'button').attr('disabled', true);
            editWrapper.find('input').val(I18n.t('loading'))
            jQuery.post(project_report_update_deadline_path({deadline: userSetValue, project_report_id: reportId, format: 'json'}), function(res) {
              if (res.errors){
                alert(validationErrorMessagesAsList(res.errors).join('\n'))
                editWrapper.find('input', 'button').attr('disabled', false);
                editWrapper.find('input').val(userSetValue)    
              } else {
                cell.data(res)
                editWrapper.hide();
                currentValueWrapper.show();
              }
            })
          })
        });
        jQuery('table.reports').on('click', '.delete-report-button', function(e) {
          e.stopPropagation();

          if (confirm(jQuery(this).attr('data-confirm'))) {
            jQuery.post(jQuery(this).attr('href'), function(res) {
              if (res.errors){
                alert(I18n.t('failed_delete_project_report'));
              } else {
                Turbo.visit(window.location.href);
              }
            })
          }
          return false;
        });
      }
      // Columns selector
      jQuery('.dropdown.variable-columns').on('click', 'input, label', ActionJS.ProjectReport.priv.updateVisibleColumns);
    },
    edit_status: function(){ //Method not used anymore
      // Old unused time picker
      // jQuery('.date').datetimepicker({ format: "YYYY-MM-DD", useCurrent: false });
      // #TODO: Test before use.
      jQuery('.date').flatpickr({ dateFormat: "Y-m-d", allowInput: true});
      jQuery('.open-datepicker').on('click', function () {
          jQuery(this).closest('.input-group').find('.date').focus();
      });
    },
    edit_deadline: function(){
      jQuery('.date').flatpickr({ dateFormat: "Y-m-d", allowInput: true});
    },
    edit_report: function() {
      jQuery('[data-tooltip]').tooltip({html: true});

      jQuery('#collapse2').on('shown.bs.collapse	hidden.bs.collapse', function(){
        jQuery('.toggle-text-on-collapse').each(function(idx){
          var current = jQuery(this).text();
          jQuery(this).text(jQuery(this).attr('data-alternative-label'));
          jQuery(this).attr('data-alternative-label', current);  
        })
      });

      jQuery('.revert-submission-button').on('click', function(e) {
        e.preventDefault();
        var $link = jQuery(this);
        ExplanationDialog.open(function(explanation){
          $.post({
            url: project_report_revert_submission_path({
              project_id: $link.data('project_id'),
              project_report_id: $link.data('project_report_id'),
            }),
            data: { explanation: explanation },
            method: 'post',
            async: true
          }).done(function(content) {
            Turbo.visit(location.href, {action: 'replace'});
            ExplanationDialog.close()
          }).error(function(error) {
            alert(I18n.t("something_went_wrong"));
          });
        }, '<p>' + I18n.t('revert_submission_warning') + '</p>')  
  
        return false;
      });

      jQuery('.cancel-signing-button').on('click', function(e) {
        e.preventDefault();
        var $link = jQuery(this);
        ExplanationDialog.open(function(explanation){
          $.post({
            url: project_report_docusign_cancel_signing_path({
              project_id: $link.data('project_id'),
              report_id: $link.data('report_id'),
            }),
            data: { 
              explanation: explanation,
              project_report_id: $link.data('project_report_id'),
              monitoring_report_phase_id: $link.data('monitoring_report_phase_id')
            },
            method: 'post',
            async: true
          }).done(function(content) {
            Turbo.visit(location.href, {action: 'replace'});
            ExplanationDialog.close()
          }).error(function(error) {
            alert(I18n.t("something_went_wrong"));
          });
        }, '<p>' + I18n.t('cancel_signing_warning') + '</p>')  
  
        return false;
      });
      jQuery('.revert-submission-button').tooltip({html: true, title: I18n.t('revert_submission_hint')});

      // Toggle display full description
      var dc = $('.report-versions .description-container');
      dc.on('click', function() {
        $(this).toggleClass('description-container', 100);
      });
      if (dc.length > 0 && isEllipsisActive($(dc).find('.description-text')[0])) {
        dc.css('width', dc.parent().innerWidth());
        dc.find('.display-text').show();
      }
      function isEllipsisActive(e) {
        return ($(e).innerWidth() < $(e)[0].scrollWidth);
      }

      // Toggle display report status graph
      var toggleReportStatusBtn = $('.toggle-report-status-graph');
      toggleReportStatusBtn.on('click', function() {
      $( '.scaled-report-status-graph, .report-status-graph').toggleClass(function() {
          if ($( '.scaled-report-status-graph').length > 0 ) {
            $(this).css('height', 'auto').removeClass('scaled-report-status-graph');
            toggleReportStatusBtn.html(I18n.t('hide'));
            return '';
          } else {
            let graph_innerHeight = $('.report-graph-component svg').innerHeight();
            $(this).css('height', graph_innerHeight - (graph_innerHeight / 2));
            toggleReportStatusBtn.html(I18n.t('show1'));
            return 'scaled-report-status-graph';
          }
        });
      });

      // Toggle display performance table
      var togglePerformanceTableBtn = $('.toggle-performance-table');
      togglePerformanceTableBtn.on('click', function() {
      $( '.report-performance-table').toggleClass(function() {
          if ($( '.hide').length > 0 ) {
            $(this).removeClass('hide');
            togglePerformanceTableBtn.html(I18n.t('hide'));
          } else {
            $(this).addClass('hide');
            togglePerformanceTableBtn.html(I18n.t('show1'));
          }
          return ''
        });
      });

      ActionJS.ProjectReport.priv.initPdfDownloadActions();
    },  
    review: function() {
      ActionJS.ProjectReport.priv.initPdfDownloadActions();
    },
    priv: {
      updateVisibleColumns: function (e) {
        var elem = jQuery(this);
  
        if (elem.is('input')) {
          var dropdown = elem.closest('.variable-columns');
          var index = parseInt(elem.attr('data-index'), 10);
          var visible = elem.prop('checked');
          var ids = [];
          var cols = [];
          dropdown.find('input').each(function () {
            if (this.checked && !isNaN(parseInt(this.value))) {
              ids.push(this.value);
            } else if (!this.checked && isNaN(parseInt(this.value))) {
              cols.push(this.value);
            }
          });
  
          ActionJS.Monitoring.priv.projectReportTable.column(index).visible(visible);
          ActionJS.Monitoring.priv.projectReportTable.draw();
          jQuery.post(dropdown.attr('data-url'), { report_variable_ids: ids, columns: cols });
        } else {
          elem.find('input').trigger('click');
          return false;
        }
  
        e.stopPropagation();
      },
      getHiddenColumns: function () {
        var hiddenColumns = [];
        jQuery('.dropdown.variable-columns input:not(:checked)').each(function () {
          hiddenColumns.push(parseInt(this.getAttribute('data-index'), 10));
        });
        return hiddenColumns;
      },
      initPdfDownloadActions: function() {
        jQuery('#pdf_actions_button').on("click", function (e) {
          var formLinkId = jQuery(".form-collection-tabs .selected").attr("data-form-link-id");
          jQuery(".dropdown-menu .replace-programme-form-link-id").each(function() {
              jQuery(this).attr("href", jQuery(this).attr("data-original-href").replace("__form_link_id__", formLinkId));
          })
        });
      }
    },
};